import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import md5 from "md5";
export var downFile = function downFile(blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = window.navigator.userAgent.indexOf('Mac OS X') !== -1 && blob.type === 'application/vnd.ms-excel' ? fileName + '.xls' : fileName;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }
};
export var encryptor = function encryptor(value) {
  if (!value) {
    return value;
  }
  var encryptor = new JSEncrypt();
  encryptor.setPublicKey("MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArc/AAyRhW5lIwROZZ1f9gQIrarKiU8c2CNJypMG3s7+QndF72rh4YFORM+EIqW5LpMjR/6Z+f4TPVDLRwygQdGXnf+dWpKWAbo3Gks3mahAFlykOe53YYuc7WkCvRoqfPxx9T/OVwUVyLCtrwz4LHlnJ8HB348SDxcbu2+8vjKV1zO+2kmr5hHLPdihzh3/lH0wmJ0J02ufIw1GnAOf3Iehy/06Lm3kfRdEkLuf4sZuW9f/UoRcTzUhqeE3EJWaWYu+CNmkEJro5W85Hany3IvldzhoVbZ1bxXCBzJK1kugZd8XopPluDKgCYLi0nRvEnskE/f0Puc8DdEbNVHBYEQIDAQAB");
  var random = Date.now().toString().substr(-4);
  var result = md5(value);
  result = "".concat(result, ",").concat(random, ",").concat(value);
  return encryptor.encrypt(result);
};
export var decryptor = function decryptor(value) {
  if (!value) {
    return;
  }
  var encryptor = new JSEncrypt();
  encryptor.setPrivateKey("MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCerXrSk/DsNAE4\n8TCLhBguv6n3Chrqj3ZzVhWmJDQNCNx4fkGHVohVvDSnj5VEo8Qw6D2fRtIkWEfM\ncsQTQ5F7haQqSY8Ku6usWOsvPuNhbvd1whnGksPKF5sgRqk0Wp/1zkVPXYQcLbcY\nJqJlP0l5qIv0HwupPJY3J4A/cQFDDtB++bcbDYGEuWYWpUVUEi32sI4qNMver3kK\n+vQ4aIHbnfzeNxXKjJp8zKQ+dQaNWUxttxkc6faGxgxtlyLVnoMOvYI2QRNn8158\nGGoyMaS8q3GvNdRBD44waChSPbKxWboGndVJTnRuIo0A+QYBYt44VnAHFtiTXySj\nQqXwO2eNAgMBAAECggEAW8U7ZrR3PzSojFU53UatccQZua2XeZc1S2k7JhaEIBHC\n6NEkdvB98w/haBNrogIRArQeh5K/EJQaGk05x2ZpqoXVNzvJxcxaclgO1QlLGlvC\nNNHodGcHY0cZyaX0UDolj1UX0tnkASQTY51ciK/8f6cSIkMeTGek/QsUahyiPTRY\nD4r1JOuPyJLKgMS8JbksOW4Y/1BL6zmIlEx0KYK+Y2kaREkF0oF9eoOBBQDw/S1A\nwvn7wB8kTcyE717gmPPkV8da9M1wSbHo1MxtywAboYaz2YMC15gTsr6ctgXJ90K7\nVrBDM26PxtzSFrOODTsLw0mLNagKLUu/8Zr+S4ploQKBgQDLM/CMKpJYnL/L8wyg\nPb4KjtlAJCGnAeQeZtYaG5w+1fxccUBQk8TUidgspEDI48NAJ82IxRcQ0EvFsSv0\n22bTAquDOj4V391N/1G1RNL3rUyN0d/4FjL0wz3kc22v1jgSjDDM+b6AAcZ+XuE8\nT9ZMOp0v42FXsiBuNzM0img1tQKBgQDH5/CVwYrN4yDiIkAnSFcqG72YietTvTIZ\nNyxhM34ENT6L4/72XCDaWmTTE4Owbwv+siJ+7+SJPjjurwv+mUJlzT7wgmUerEet\nJMFXCuY7omsV3tDC/an3/5CDGQk+zg0ENX1bmq0TtJA/DLcckU3wkPeieIgmoSmo\nkudKZWUReQKBgQCQqF4jep8KZDSJ/XHMlYe3vm/coJwwZ0E9f1oF5gf6F537NUhi\n1H94CtWRGjFgkfxKrMs+BYjhGFgI2ZMAUjzGFQ2CczEFo4PJZeyGDgPd/EoWYAWA\neFU4N9HU03OPjQIH+jM3iMdcG2dySRsxM2jMhaGnGMkQhCdgLv3N9oYvTQKBgAzp\nbT+u/ZEoz3HrtmsTIBYnLorQtbN17+tzBdnNYqFQ8xZEBq7Q6opP9l0v0Hyv3312\n8gVy5zb6HuFDyymJqqE6rYsJURC3HfYP/rDpkk9dwT7rYl6F1dmf1yywjElTM8IG\n1m75QZ6ZNgvsfVNKC1ezdVs4H8sm87LgsjG69Nk5AoGAIcTxoZPy5Zd4Xz8BMrfi\nl62diO1PBKCcTChdRDczOhxk7fbIyy6Nnl8OuSLrkunrYtjMofgl95dkFM3EAjeR\npUSlMrKk63eN/AtlcrNyGddbYvUIyp6jXb11rmB8Jx2JAi63XUaI/geX5MB4TrBq\nVxk4Nh1TzKMdquewzFIruaU=");
  try {
    var temp = encryptor.decrypt(value).split(',');
    console.log('temp---', temp);
    var result = md5(temp[2]);
    console.log('temp---', temp, 'result----', result);
    if (result === temp[0]) {
      return temp[2];
    }
  } catch (err) {}
};

// 是否显示时刻底部导航栏
export var hideTitleBar = function hideTitleBar(ostype) {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
  try {
    if (ostype == "android") {
      verifyJsBridge.postNotification('hideTitleBar', JSON.stringify({}));
    } else if (ostype == "ios") {
      window.webkit.messageHandlers['hideTitleBar'].postMessage(null);
    } else if (ostype == "HarmonyOS") {
      HarmonyOSJsBridge['hideTitleBar'](null);
    }
  } catch (error) {
    alert(error);
  }
};

// 时刻关闭当前窗口
export var closeH5Link = function closeH5Link(ostype) {
  try {
    if (ostype == "android") {
      verifyJsBridge.postNotification('closeH5Link', JSON.stringify({}));
    } else if (ostype == "ios") {
      window.webkit.messageHandlers['closeH5Link'].postMessage(null);
    } else if (ostype == "HarmonyOS") {
      HarmonyOSJsBridge['closeH5Link'](null);
    }
  } catch (error) {
    alert(error);
  }
};

// 打开时刻分享
export var openShare = function openShare(params, ostype) {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
  try {
    if (ostype == "android") {
      verifyJsBridge.postNotification('JSShare', JSON.stringify(params));
    } else if (ostype == "ios") {
      window.webkit.messageHandlers['JSShare'].postMessage(params);
    } else if (ostype == "HarmonyOS") {
      HarmonyOSJsBridge['JSShare'](params);
    }
  } catch (error) {
    alert(error);
  }
};

// 设置系统状态栏颜色
export var setStatusBarStyle = function setStatusBarStyle(params, ostype) {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
  try {
    if (ostype == "android") {
      verifyJsBridge.postNotification('setStatusBarStyle', JSON.stringify(params));
    } else if (ostype == "ios") {
      window.webkit.messageHandlers['setStatusBarStyle'].postMessage(params);
    } else if (ostype == "HarmonyOS") {
      HarmonyOSJsBridge['setStatusBarStyle'](params);
    }
  } catch (error) {
    alert(error);
  }
};